module.exports = __webpack_public_path__ + "static/media/CosAssessmentsAssessReview.a67d3d0a.png";